import { AutocompleteOption, FormCheckbox } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';
import {
  BusinessUnitsFilterBranchOffice,
  BusinessUnitsFilterFormContext,
} from './filter-business-units.types';
import { getBusinessUnitsOptions } from './get-business-units-options';
import { FilterBusinessUnitsSelect } from '../business-units-with-company/filter-business-units-multi-select';
import { filterValidDepartments } from '../../utils/utils';

type Props = {
  branchOffices: BusinessUnitsFilterBranchOffice[];
};

export const FilterBusinessUnits = (props: Props) => {
  const { branchOffices } = props;
  const { setValue, watch, control } = useFormContext<BusinessUnitsFilterFormContext>();

  const {
    branchOffices: selectedBranchOffices,
    businessUnitCheckboxValue: selectedBusinessUnitCheckbox,
    departments: selectedDepartments,
  } = watch();

  useEffect(() => {
    const filteredDepartments = filterValidDepartments({
      selectedDepartments,
      selectedBranchOffices,
      branchOffices,
    });

    if (filteredDepartments.length !== (selectedDepartments?.length || 0)) {
      setValue('departments', filteredDepartments);
    }
  }, [selectedBranchOffices, selectedDepartments, branchOffices, setValue]);

  const options = useMemo(() => {
    return getBusinessUnitsOptions(
      branchOffices,
      selectedBranchOffices as AutocompleteOption[] | undefined
    );
  }, [branchOffices, selectedBranchOffices]);

  return (
    <>
      <Box>
        <FormCheckbox
          name="businessUnitCheckboxValue"
          control={control}
          label="Bedrijfseenheid"
          isHeaderCheckbox={true}
        />
      </Box>
      {selectedBusinessUnitCheckbox ? (
        <>
          <FilterBusinessUnitsSelect
            formName="branchOffices"
            label="Vestigingen"
            options={options.branchOffices}
          />

          <FilterBusinessUnitsSelect
            formName="departments"
            label="Afdelingen"
            options={options.departments}
            disabled={!selectedBranchOffices}
          />
        </>
      ) : null}
    </>
  );
};
